import React from "react";
import { LinkIcon } from "@/components/icons";

function formatResourceLabel(url: string, note?: string): string {
  if (note) return note;
  return url.replace(/^https?:\/\//, "").split("/")[0];
}

interface ResourcePillProps {
  url: string;
  note?: string;
  onRemove?: () => void;
  isRemoving?: boolean;
  maxWidth?: string;
}

export const ResourcePill: React.FC<ResourcePillProps> = ({
  url,
  note,
  onRemove,
  isRemoving = false,
  maxWidth = "max-w-[140px]",
}) => {
  const label = formatResourceLabel(url, note);

  return (
    <div className="group/resource inline-flex items-center gap-1 px-2.5 py-1 text-[10px] font-medium text-gray-600 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors">
      <LinkIcon className="w-3 h-3 shrink-0" />
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={`truncate hover:text-blue-600 ${maxWidth}`}
      >
        {label}
      </a>
      {onRemove && (
        <button
          onClick={(e) => { e.stopPropagation(); onRemove(); }}
          disabled={isRemoving}
          className="p-0.5 text-gray-400 hover:text-rose-600 opacity-0 group-hover/resource:opacity-100 transition-opacity shrink-0"
        >
          <svg className="w-2.5 h-2.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}
    </div>
  );
};
